/**
 * levelMeta.js — pure level/threshold logic for the crystal island.
 *
 * Extracted from hud.js so it can be unit-tested without a DOM
 * (hud.js touches document.* at module scope). Single source for
 * LEVEL_META / THRESHOLDS — hud.js and crystal.js both read from here.
 */

export const LEVEL_META = {
  // labelKey, not label: the SAME four names are rendered by the mobile app's
  // GamePortalCard under identical keys, so the two surfaces cannot drift.
  1: { labelKey: 'game.level_1', color: '#7C6AF7', nextAt: 200 },
  2: { labelKey: 'game.level_2', color: '#5B9CF6', nextAt: 800 },
  3: { labelKey: 'game.level_3', color: '#4BC8A0', nextAt: 3000 },
  4: { labelKey: 'game.level_4', color: '#F0A500', nextAt: null },
}

export const THRESHOLDS = [0, 200, 800, 3000]

/**
 * Percentage progress toward the next level, clamped to [0, 100].
 * @param {number} level        current level (1..4)
 * @param {number} totalSpent   cumulative P spent
 * @returns {number}
 */
export function computePct(level, totalSpent) {
  if (level >= 4) return 100
  const start = THRESHOLDS[level - 1] ?? 0
  const end = THRESHOLDS[level] ?? 3000
  return Math.max(0, Math.min(Math.round(((totalSpent - start) / (end - start)) * 100), 100))
}
